export default {
    1: 'یک',
    2 : 'دو',
    3 : 'سه',
    4 : 'چهار',
    5 : 'پنج',
    6 : 'شش',
    7 : 'هفت',
    8 : 'هشت',
    9 : 'نه',
    10 : 'ده',
    'یک': 1,
    'دو': 2,
    'سه': 3,
    'چهار': 4,
    'پنج': 5,
    'شش': 6,
    'هفت': 7,
    'هشت': 8,
    'نه': 9,
    'ده': 10,
}